import { render, staticRenderFns } from "./modalReminder.vue?vue&type=template&id=67e6b07e&"
import script from "./modalReminder.vue?vue&type=script&lang=js&"
export * from "./modalReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports